export default {
    install: (app:any, options:any) => {
        const logout = () => {
            //console.log("Logout is being called");
          };
      
          app.provide("logout", logout);
    },
  };